/**
 * Account type values
 */
export enum AccountTypeEnum {
	COMPANY = 'company',
	INDIVIDUAL = 'individual',
}
